module.exports = __webpack_public_path__ + "Cloud_Community.44c9d3e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/portal_icons/Cloud_Community.png
// module id = 415
// module chunks = 0